const EntityStatus = {
  ACTIVATED: 1,
  INACTIVE: 0
}
export default EntityStatus
